module.exports = __webpack_public_path__ + "static/007207-3d9ca30c8f553db20910d4d2f51aaabe.jpg";